import { render, staticRenderFns } from "./保有不動産.vue?vue&type=template&id=3ad8c287&scoped=true&"
import script from "./保有不動産.ts?vue&type=script&lang=ts&"
export * from "./保有不動産.ts?vue&type=script&lang=ts&"
import style0 from "./保有不動産.css?vue&type=style&index=0&id=3ad8c287&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad8c287",
  null
  
)

export default component.exports